export default "__VITE_ASSET__BcLga0aH__"